module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "factoring_main w"
  }, [_vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "condition"
  }, [_vm._m(3), _vm._v(" "), _c('ul', {
    staticClass: "condition_list"
  }, _vm._l((_vm.conditionArr), function(item, index) {
    return _c('li', {
      key: index,
      staticClass: "condition_li"
    }, [_c('span', [_vm._v(_vm._s(item.compactName))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.compactMain))])])
  }), 0)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "factoring"
  }, [_c('div', {
    staticClass: "factoring_tit w"
  }, [_c('h2', {
    staticClass: "factoring_h"
  }, [_vm._v("融资租赁")]), _vm._v(" "), _c('div', {
    staticClass: "limit"
  }, [_c('p', [_vm._v("额度申请")]), _vm._v(" "), _c('p', [_vm._v("客户有意向平台发起融资申请时，需要先进行额度申请，平台对客户进行尽调，授信一定的额度，客户可在额度范围内进行融资申请。")])]), _vm._v(" "), _c('div', {
    staticClass: "financing limit"
  }, [_c('p', [_vm._v("融资租赁申请")]), _vm._v(" "), _c('p', [_vm._v("可录入或导入设备明细，录入融资金额，选择融资模式、提交融资申请，平台审核通过后签订租赁合同，进入放款流程。")])]), _vm._v(" "), _c('button', {
    staticClass: "factoring_btn"
  }, [_vm._v("立即申请")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lease"
  }, [_c('div', {
    staticClass: "presentation_l f_public"
  }, [_c('div', [_vm._v("直租")]), _vm._v(" "), _c('p', [_vm._v("借款人租赁设备，租赁公司付款给设备 供应商，借款人分期支付租金给租赁公 司，到期产权转移给借款人。 租赁公司需与供应商签订买卖")])]), _vm._v(" "), _c('div', {
    staticClass: "presentation_r f_public"
  }, [_c('div', [_vm._v("回租")]), _vm._v(" "), _c('p', [_vm._v("借款人将设备抵押给租赁公司，获得流 动资金，然后分期支付租金给支付公司， 到期产权转移给借款人。 借款人需与租赁公司签订租赁合")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flow"
  }, [_c('p', {
    staticClass: "flow_h tit_public colorF"
  }, [_c('span', {
    staticClass: "tit_span"
  }, [_vm._v("申请流程")])]), _vm._v(" "), _c('div', {
    staticClass: "flow_img"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/lease.png"),
      "alt": ""
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "condition_h tit_public"
  }, [_c('span', {
    staticClass: "tit_span"
  }, [_vm._v("申请条件及所需资料")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8e46febc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/products/Lease.vue
// module id = 1085
// module chunks = 1